import { Injectable, inject } from '@angular/core'
import { Filter, HttpParamsBuilder, RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { WorkCenterUtilisation } from './work-center-utilisation'
import { Observable } from 'rxjs'
import { Constraint } from '../../shopfloor/workcenters/capability/constraints/constraint'
import { WorkItemFilter } from '../work-items/work-item.service'

@Injectable({
  providedIn: 'root',
})
export class WorkCenterUtilisationService extends RestClientList<WorkCenterUtilisation, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)
    super(environment.apiPath + '/utilisation/work-centers', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public findWorkCenterUtilisation(
    workCenterId: string,
    utilisationFilter: Filter[],
    constraints: Constraint[]
  ): Observable<WorkCenterUtilisation> {
    return this.findById(
      workCenterId,
      HttpParamsBuilder.start()
        .appendFilters(utilisationFilter)
        .appendFilter(WorkItemFilter.constraints(constraints))
        .build()
    )
  }
}
